export default __webpack_public_path__ + "static/media/diners-club.d6fdb52f.svg";